import { cloneDeep } from 'lodash'
import { ServiceProperty } from 'schemas/ServicePropertySchema'
import ComparisonMode from 'enums/ComparisonMode'
import { CrosstabWidgetsType } from '../../types'
import {
  getPivotThemeIds,
  getPivotRowThemeIds,
  getComparisonMode
} from '../utils/crosstabDataUtils'

export const servicePropertySetter = (
  widgetSetting: CrosstabWidgetsType,
  serviceProperties: ServiceProperty
) => {
  const resultServiceProperties = cloneDeep(serviceProperties)

  const pivotThemeIds = getPivotThemeIds(widgetSetting)
  const pivotRowThemeIds = getPivotRowThemeIds(widgetSetting)

  resultServiceProperties.rowThemeIds = pivotRowThemeIds
  resultServiceProperties.themeIds = pivotThemeIds
  resultServiceProperties.rowTagNames = widgetSetting.rowTagNames
  resultServiceProperties.tagNames = widgetSetting.tagNames
  resultServiceProperties.rowDocNames = widgetSetting.rowDocNames
  resultServiceProperties.docNames = widgetSetting.docNames

  const { colComparisonMode, rowComparisonMode } = getComparisonMode(widgetSetting)
  resultServiceProperties.colComparisonMode = colComparisonMode
  resultServiceProperties.rowComparisonMode = rowComparisonMode

  return resultServiceProperties
}

export const grandTotalPropertySetter = (
  widgetSetting: CrosstabWidgetsType,
  serviceProperties: ServiceProperty
) => {
  const resultServiceProperties = servicePropertySetter(widgetSetting, serviceProperties)

  resultServiceProperties.colComparisonMode = ComparisonMode.NONE
  resultServiceProperties.themeIds = resultServiceProperties.rowThemeIds
  resultServiceProperties.docNames = resultServiceProperties.rowDocNames
  resultServiceProperties.tagNames = serviceProperties.rowTagNames

  return resultServiceProperties
}
